import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundry from './ErrorBoundry';
import HandleGlobalError from './HandleGlobalError';

export default function ErrorHandler({ children }) {
  return (
    <ErrorBoundry>
      <HandleGlobalError />
      {children}
    </ErrorBoundry>
  );
}
ErrorHandler.propTypes = {
  children: PropTypes.node.isRequired,
};
